import { type DietaryPropertyKind } from '@sg/graphql-schema';

import { type DietaryRestrictionsTypes } from '../setup';

// ─────────────────────────────────────────────────────────────────────────────

export function sortRestrictionsByName(restrictions: DietaryRestrictionsTypes) {
  const restrictionsNames = Object.keys(restrictions);
  const sortedRestrictions = [...restrictionsNames].sort(compareAlphabetically);

  return sortedRestrictions as DietaryPropertyKind[];
}

// ─────────────────────────────────────────────────────────────────────────────

function compareAlphabetically(restriction: string, nextRestriction: string) {
  return restriction.localeCompare(nextRestriction);
}
